import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { QuoteDataCaptureService } from '../../../../shared';

@Component({
  selector: 'app-ho-summary-underwriting',
  templateUrl: './ho-summary-underwriting.component.html',
  styleUrls: ['./ho-summary-underwriting.component.scss']
})
export class HoSummaryUnderwritingComponent implements OnInit, AfterViewInit, OnDestroy  {

  urlforHOUnderwriting = '';
  quoteRefNo = '';
  formSessionId = '';
  interval: any;
  constructor(private quoteDatacaptureService: QuoteDataCaptureService) {
    // tslint:disable-next-line: max-line-length

   }

  ngOnInit() {
    this.quoteRefNo = this.quoteDatacaptureService.getRefNum();
    this.formSessionId = this.quoteDatacaptureService.getFormSessionId();
   // this.urlforHOUnderwriting = 'http://retirements-qa2-weu-in.lgnet.co.uk:8080/eap/dcj/#/home/get-your-online-quote';
    this.quoteDatacaptureService.GetRefnumberEncrypted(this.quoteRefNo).subscribe(refData => {
      this.quoteDatacaptureService.GetFormSessionIdEncrypted(this.formSessionId).subscribe(formSessionData => {
        this.urlforHOUnderwriting = '/eap/request/dcj/triggerUnderwrtingHo?refId=' + refData.quoteReference
          + '&formSessionId=' + formSessionData.formSessionId;
      });
    });
    //console.log( this.urlforHOUnderwriting);
  }
  onLoadFunc(myIframe) {
    const iframeEle = myIframe.contentDocument || myIframe.contentWindow;
    if (iframeEle.getElementsByName('summaryForm').length > 0 ) {
        //clearInterval(interval);
        window.parent.postMessage('validateUnderwriting', '*');
      }

  }
  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'impleme
    // setTimeout(() => {
    //   window.parent.postMessage('validateUnderwriting', '*');
    // }, 4000);

  }
  ngOnDestroy() {
    //clearInterval(this.interval);
  }

}
